import axios from 'axios';
import request from './api';
import {
  API_SOCIAL,
  API_PRESS_RESUME,
  API_NEWS_REVIEWS,
  API_EMPLOYEE_HCM_LIST,
  API_EMPLOYEE_CERTIFICATE_LIST,
  API_DIGITAL_AUDIENCE,
  API_DIGITAL_AUDIENCE_RECENT,
  API_RADIO_AUDIENCE,
  API_RADIO_AUDIENCE_RECENT,
  API_RRSS_AUDIENCE,
  API_RRSS_AUDIENCE_RECENT,
  API_STRATEGY,
  API_STRATEGY_RECENT
} from '../constants/api';

/** EMPLOYEE LIST */
/**
 * Retrieves the data of the employees.
 * @param {string} orderby NAME
 * @param {string} name
 * @param {string} lastname
 * @param {string} idDepartment
 * @param {string} extension
 * @param {string} phones
 * @param {string} size
 * @param {string} page
 * @param {string} direction  ASC|DESC
 */
// orderby, name,lastname,idDepartment,extension,phones,size,page,direction
export const getEmployeeList = ({
  orderby = 'NAME',
  name,
  lastname,
  alias,
  department,
  extension,
  phones,
  employeeId,
  size = 20,
  page = 0,
  direction = 'ASC'
}) =>
  request(API_EMPLOYEE_HCM_LIST, {
    method: 'GET',
    params: {
      orderby,
      name,
      lastname,
      alias,
      department,
      extension,
      phones,
      employeeId,
      size,
      page,
      direction
    }
  });

/** EMPLOYEE HOLDING CERTIFICATION LIST */
/**
 * Retrieves the data of the employees with holding certification.
 * @param {string} orderby NAME
 * @param {string} name
 * @param {string} lastname
 * @param {string} idDepartment
 * @param {string} extension
 * @param {string} phones
 * @param {string} size
 * @param {string} page
 * @param {string} direction  ASC|DESC
 */
// orderby, name,lastname,idDepartment,extension,phones,size,page,direction
export const getEmployeeCertificateList = ({ size = 20, page = 0 }) =>
  request(API_EMPLOYEE_CERTIFICATE_LIST, {
    method: 'GET',
    params: {
      size,
      page
    }
  });

/** TRAFFIC */
/**
 * Retrieves the data of the traffic. If lat and long are undefined, the office location will be used
 * @param {Number} lat Latitude
 * @param {Number} long Longitude
 */
export const getTraffic = (lat, long) =>
  request(`${API_SOCIAL}widget/googlemaps`, {
    method: 'GET',
    params: {
      latitude: lat,
      longitude: long
    }
  });

/**
 * Set the config for the user.
 * @param {String} method 'POST' if the user has id or 'PUT' if not
 * @param {String} userAddress New address of this user
 * @param {Number} id User id in the database for using the Google services
 */
export const setTrafficConfig = (method, userAddress, id = null) =>
  request(`${API_SOCIAL}widget/googlemaps/config`, {
    method,
    data: {
      active: true,
      userAddress,
      id
    }
  });

export const getDigitalAudience = fromDate =>
  request(API_DIGITAL_AUDIENCE, {
    method: 'GET',
    params: {
      date: fromDate
    }
  });

export const getRadioAudience = fromDate =>
  request(API_RADIO_AUDIENCE, {
    method: 'GET',
    params: {
      date: fromDate
    }
  });

export const getRRSSAudience = fromDate =>
  request(API_RRSS_AUDIENCE, {
    method: 'GET',
    params: {
      date: fromDate
    }
  });

export const getRRSSAudienceRecent = () =>
  request(API_RRSS_AUDIENCE_RECENT, {
    method: 'GET',
    params: {
      size: 5
    }
  });

export const getStrategy = fromDate =>
  request(API_STRATEGY, {
    method: 'GET',
    params: {
      date: fromDate
    }
  });

export const getStrategyRecent = () =>
  request(API_STRATEGY_RECENT, {
    method: 'GET',
    params: {
      size: 5
    }
  });

export const getDigitalAudienceRecent = () =>
  request(API_DIGITAL_AUDIENCE_RECENT, {
    method: 'GET',
    params: {
      size: 5
    }
  });

export const getRadioAudienceRecent = () =>
  request(API_RADIO_AUDIENCE_RECENT, {
    method: 'GET',
    params: {
      size: 5
    }
  });

export const getPressResume = fromDate =>
  request(API_PRESS_RESUME, {
    method: 'GET',
    params: {
      date: fromDate
    }
  });

export const getNewsReview = () =>
  request(API_NEWS_REVIEWS, {
    method: 'GET',
    params: {
      size: 5
    }
  });

/**
 * Get info of the traffic widget for the current user
 */
export const getTrafficConfig = () =>
  request(`${API_SOCIAL}widget/googlemaps/config`, {
    method: 'GET'
  });

/** WEATHER */
export const getWeather = (lat = '40.5682479', lon = '-3.6204052') =>
  axios('https://api.openweathermap.org/data/2.5/weather', {
    method: 'GET',
    params: {
      id: '3110040',
      appid: 'c1d69b3094886faf8501125e56e17c29',
      lang: 'es',
      units: 'metric',
      lat,
      lon
    }
  });
// axios(
//   `https://api.openweathermap.org/data/2.5/weather?id=3110040&appid=c1d69b3094886faf8501125e56e17c29&lang=es&units=metric`
// );

/**
 * Remove traffic widget configuration
 */
export const removeTrafficConfig = () =>
  request(`${API_SOCIAL}widget/googlemaps/config`, {
    method: 'DELETE'
  });
